import { render, staticRenderFns } from "./ProductDesign.vue?vue&type=template&id=94fcb4b6&"
import script from "./ProductDesign.vue?vue&type=script&lang=js&"
export * from "./ProductDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports